import React from 'react';

import SpringBoard from '../containers/SpringBoardContainer';

const SpringBoardAppClient = (props) => (
  <SpringBoard {...props} />
);

export default SpringBoardAppClient;
